<template>
    <fragment>
        <div class="form-group">
            <label class="media-label">{{ language.add_type_media_legend }}</label>
            <textarea v-model="dataStore.active3dIframe" class="form-control" type="text" placeholder="3D-iframe" rows="6"></textarea>
            <span style="color: red;" v-if="error">{{ error.error }}</span>
        </div>
    </fragment>
</template>

<script>

import dataStore from "../../store";
import globalFunctions from "../../globalFunctions";
import { Fragment } from 'vue-fragment'

export default {

    data() {
        return {
            dataStore,
            globalFunctions,
        }
    },

    inject: [ 'language' ],

    components : {
        Fragment
    },

    computed: {
        error: function() {
            if(this.dataStore.errorsAdmin.length) {
                let error = this.dataStore.errorsAdmin.filter(err => err.name === '3d').pop()
                return error ? error : false
            }

            return false
        }
    },

};
</script>
